import { useTranslation } from 'react-i18next'

import { APP_EMAIL, FB_FUN_PAGE } from 'client/utils'
import { getAssetUrl } from 'client/services'
import { usePage, useEnvContext } from 'client/hooks'

import {
  AppButton,
  AppParagraph,
  AppHeader,
  AppImage,
  AppGroup,
  AppFlexContainer,
  AppFlexItem,
} from 'client/ui-building-blocks'

import styles from './footer.module.scss'

const Footer = () => {
  const { t } = useTranslation()
  const { navigateTo } = usePage()
  const { donationPaymentLink } = useEnvContext()

  const onAboutMoreClick = () => {
    navigateTo({ path: '/about' })
  }

  const onDonationMoreClick = () => {
    window.open(donationPaymentLink, '_blank')
  }

  return (
    <div data-testid="footer" className={styles.footer}>
      <AppFlexContainer flexWrap="wrap" border>
        <AppFlexItem
          flexGrow={1}
          flexBasis="33.3%"
          minWidth="300px"
          minHeight="275px"
          padding="25px"
        >
          <AppHeader
            text={t('rootPage.footer.section1.header')}
            centered
            color="light"
            size="small"
            decoration="underlined"
            marginBottom="xsmall"
          />
          <AppParagraph
            text={t('rootPage.footer.section1.content')}
            color="light"
            size="small"
            marginBottom="small"
          />
          <AppButton
            variant="success"
            text={t('common.buttons.more')}
            position="center"
            onClick={onAboutMoreClick}
          />
        </AppFlexItem>
        <AppFlexItem
          flexGrow={1}
          flexBasis="33.3%"
          minWidth="300px"
          minHeight="275px"
          padding="25px"
        >
          <AppHeader
            text={t('rootPage.footer.section2.header')}
            centered
            decoration="underlined"
            color="light"
            size="small"
            marginBottom="xsmall"
          />
          <AppParagraph
            text={t('rootPage.footer.section2.content')}
            color="light"
            size="small"
            marginBottom="small"
          />
          <AppGroup alignment="vertical" position="center" gapSize="medium">
            <AppButton
              variant="info"
              text={t('rootPage.footer.section3.fbBtn')}
              position="center"
              iconName="SHARE_SQUARE"
              iconPosition="right"
              href={FB_FUN_PAGE}
            />
            <AppButton
              variant="info"
              text={APP_EMAIL}
              position="center"
              href={'mailto:' + APP_EMAIL}
            />
          </AppGroup>
        </AppFlexItem>
        <AppFlexItem
          flexGrow={1}
          flexBasis="33.3%"
          minWidth="300px"
          minHeight="275px"
          padding="25px"
        >
          <AppHeader
            text={t('rootPage.footer.section3.header')}
            centered
            decoration="underlined"
            color="light"
            size="small"
            marginBottom="xsmall"
          />
          <AppParagraph
            text={t('rootPage.footer.section3.content')}
            color="light"
            size="small"
            marginBottom="small"
          />
          <AppImage
            src={getAssetUrl('stripe-logo.png')}
            width="225px"
            height="58px"
            alt="stripe-logo"
            onClick={onDonationMoreClick}
            centered
          />
        </AppFlexItem>
      </AppFlexContainer>
    </div>
  )
}

export default Footer
